const API_CONFIG =  {base_url: process.env.REACT_APP_API_CONFIG,
										 user: process.env.REACT_APP_API_USER,
										 paswword: process.env.REACT_APP_API_PASS,
										 qr_api: process.env.REACT_APP_QR_API } ;
export {
    API_CONFIG
  }
  
//test http://cicdinnovap1test-env.eba-pqm94ukp.us-east-1.elasticbeanstalk.com
//prod  http://innovap1.us-east-1.elasticbeanstalk.com  = https://back.innovasalud.bo 